import ElectrifyComponent from './components/electrify-react'

export default function createElectrifyComponent(pureStats){
	return ElectrifyComponent(pureStats);
}


// WEBPACK FOOTER //
// ./src/index.js